import { useEffect } from 'react';

export default function useMotionSensor(onTrigger, isEnabled = true) {
  useEffect(() => {
    if (!isEnabled || !window.DeviceMotionEvent) return;

    const sensitivity = 15;
    let lastTriggerTime = 0;
    const cooldownPeriod = 1000; // 1 segundo entre triggers

    const handleMotion = (event) => {
      const now = Date.now();
      if (now - lastTriggerTime < cooldownPeriod) return;

      const acceleration = event.accelerationIncludingGravity;
      if (acceleration && Math.abs(acceleration.z) > sensitivity) {
        lastTriggerTime = now;
        onTrigger();
      }
    };

    window.addEventListener('devicemotion', handleMotion);
    return () => window.removeEventListener('devicemotion', handleMotion);
  }, [onTrigger, isEnabled]);
}